import { WizardOptions } from '../utils/types';

export interface ReactNativeWizardOptions extends WizardOptions {
  uninstall: boolean;
}
